<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center"><em>To Hugo, the most valuable to me<br/>thanks to his constant presence and for the love<br/>that he gives me every day of his life …</em></p>
<p class="center"><em>To Silvia, for her love and her unconditional support in everything I do …</em></p>
<p class="center"><em>To my mother, for always supporting and encouraging me …</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312375942_epub_ded_r1.vue?5b702ff3